<div
  *ngIf="!showSpinner"
  class="h-screen w-screen bg-cover bg-center"
  style="background-image: url(&quot;assets/img/01-BG_AC_Force_N.png&quot;)"
>
  <div
    class="flex h-full w-full items-center justify-center bg-slate-900/70 backdrop-blur-md px-4"
  >
    <ng-container [ngSwitch]="viewState">
      <!-- Confirmé (nouvelle confirmation) -->
      <div
        *ngSwitchCase="'confirmed'"
        class="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl dark:bg-gray-800"
        role="status"
      >
        <div class="bg-emerald-600 px-6 py-8 text-center sm:px-8">
          <div
            class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/15 ring-4 ring-white/20"
          >
            <svg
              class="h-7 w-7 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
              />
            </svg>
          </div>
          <p
            class="text-xs font-medium uppercase tracking-wider text-emerald-100"
          >
            Inscription confirmée
          </p>
          <h3 class="mt-1 text-lg font-semibold text-white">
            {{ data?.activityName | titlecase }}
          </h3>
        </div>

        <div class="px-6 py-6 sm:px-8">
          <p
            class="mb-6 text-sm leading-relaxed text-gray-500 dark:text-gray-300"
          >
            Merci {{ data?.beneficiaryFirstName }}
            {{ data?.beneficiaryLastName }}, votre participation a bien été
            enregistrée. Voici un récapitulatif de votre rendez-vous.
          </p>

          <dl class="divide-y divide-gray-100 dark:divide-gray-700">
            <div class="flex items-start gap-2.5 py-3">
              <svg
                class="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                />
              </svg>
              <div class="min-w-0 flex-1">
                <dt class="text-xs text-gray-400 dark:text-gray-500">Date</dt>
                <dd
                  class="text-sm font-medium capitalize text-gray-800 dark:text-gray-100"
                >
                  {{ data?.activityDate | date: "EEEE d MMMM y" }}
                </dd>
              </div>
            </div>

            <div class="flex items-start gap-2.5 py-3">
              <svg
                class="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6v6l4 2"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <div class="min-w-0 flex-1">
                <dt class="text-xs text-gray-400 dark:text-gray-500">Heure</dt>
                <dd
                  class="text-sm font-medium text-gray-800 dark:text-gray-100"
                >
                  {{ data?.activityHours?.substring(0, 5) }}
                </dd>
              </div>
            </div>

            <div class="flex items-start gap-2.5 py-3">
              <svg
                class="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                />
              </svg>
              <div class="min-w-0 flex-1">
                <dt class="text-xs text-gray-400 dark:text-gray-500">Lieu</dt>
                <dd
                  class="text-sm font-medium text-gray-800 dark:text-gray-100"
                >
                  {{ data?.activityAddress }}
                </dd>
              </div>
            </div>
          </dl>

          <p class="mt-6 text-center text-xs text-gray-400 dark:text-gray-500">
            Vous pouvez fermer cette page en toute sérénité.
          </p>
        </div>
      </div>

      <!-- Déjà confirmé -->
      <div
        *ngSwitchCase="'already-confirmed'"
        class="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl dark:bg-gray-800"
        role="status"
      >
        <div class="bg-blue-600 px-6 py-8 text-center sm:px-8">
          <div
            class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/15 ring-4 ring-white/20"
          >
            <svg
              class="h-7 w-7 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
              />
            </svg>
          </div>
          <p class="text-xs font-medium uppercase tracking-wider text-blue-100">
            Déjà confirmé
          </p>
          <h3 class="mt-1 text-lg font-semibold text-white">
            {{ data?.activityName | titlecase }}
          </h3>
        </div>

        <div class="px-6 py-6 sm:px-8">
          <p
            class="mb-6 text-sm leading-relaxed text-gray-500 dark:text-gray-300"
          >
            Bonjour {{ data?.beneficiaryFirstName }}, vous aviez déjà confirmé
            votre participation à cette activité. Voici le récapitulatif de
            votre rendez-vous.
          </p>

          <dl class="divide-y divide-gray-100 dark:divide-gray-700">
            <div class="flex items-start gap-2.5 py-3">
              <svg
                class="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                />
              </svg>
              <div class="min-w-0 flex-1">
                <dt class="text-xs text-gray-400 dark:text-gray-500">Date</dt>
                <dd
                  class="text-sm font-medium capitalize text-gray-800 dark:text-gray-100"
                >
                  {{ data?.activityDate | date: "EEEE d MMMM y" }}
                </dd>
              </div>
            </div>

            <div class="flex items-start gap-2.5 py-3">
              <svg
                class="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6v6l4 2"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <div class="min-w-0 flex-1">
                <dt class="text-xs text-gray-400 dark:text-gray-500">Heure</dt>
                <dd
                  class="text-sm font-medium text-gray-800 dark:text-gray-100"
                >
                  {{ data?.activityHours?.substring(0, 5) }}
                </dd>
              </div>
            </div>

            <div class="flex items-start gap-2.5 py-3">
              <svg
                class="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                />
              </svg>
              <div class="min-w-0 flex-1">
                <dt class="text-xs text-gray-400 dark:text-gray-500">Lieu</dt>
                <dd
                  class="text-sm font-medium text-gray-800 dark:text-gray-100"
                >
                  {{ data?.activityAddress }}
                </dd>
              </div>
            </div>
          </dl>

          <p class="mt-6 text-center text-xs text-gray-400 dark:text-gray-500">
            Vous pouvez fermer cette page en toute sérénité.
          </p>
        </div>
      </div>

      <!-- Fermé -->
      <div
        *ngSwitchCase="'closed'"
        class="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl dark:bg-gray-800"
        role="status"
      >
        <div class="bg-slate-700 px-6 py-8 text-center sm:px-8">
          <div
            class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/10 ring-4 ring-white/15"
          >
            <svg
              class="h-7 w-7 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m0 3.75h.008v.008H12v-.008ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </div>
          <p
            class="text-xs font-medium uppercase tracking-wider text-slate-300"
          >
            Confirmations closes
          </p>
          <h3 class="mt-1 text-lg font-semibold text-white">
            {{ data?.activityName | titlecase }}
          </h3>
        </div>

        <div class="px-6 py-8 text-center sm:px-8">
          <p class="text-sm leading-relaxed text-gray-500 dark:text-gray-300">
            Les confirmations à cette activité sont désormais fermées. Nous ne
            pouvons plus enregistrer votre participation.
          </p>
          <p
            class="mt-4 text-sm leading-relaxed text-gray-500 dark:text-gray-300"
          >
            Pour toute question, contactez l'équipe organisatrice.
          </p>
        </div>
      </div>

      <!-- Erreur (activité/bénéficiaire/participant introuvable, ou erreur technique) -->
      <div
        *ngSwitchDefault
        class="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl dark:bg-gray-800"
        role="status"
      >
        <div class="bg-red-600 px-6 py-8 text-center sm:px-8">
          <div
            class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/10 ring-4 ring-white/15"
          >
            <svg
              class="h-7 w-7 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m0 3.75h.008v.008H12v-.008ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </div>
          <p class="text-xs font-medium uppercase tracking-wider text-red-100">
            Une erreur est survenue
          </p>
        </div>

        <div class="px-6 py-8 text-center sm:px-8">
          <p class="text-sm leading-relaxed text-gray-500 dark:text-gray-300">
            Nous n'avons pas pu traiter votre confirmation. Le lien utilisé
            n'est peut-être plus valide.
          </p>
          <p
            class="mt-4 text-sm leading-relaxed text-gray-500 dark:text-gray-300"
          >
            Pour toute question, contactez l'équipe organisatrice.
          </p>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- <div
  *ngIf="!showSpinner"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Votre participation au bootcamp
              <span *ngIf="activity">« {{ activity.nomActivity }} »</span>
              a bien été enregistrée.
            </h3>
            <p *ngIf="activity" class="text-sm text-gray-500 dark:text-gray-400">
              Rendez-vous le
              {{ activity.openDate | date : "EEEE d MMMM y" }}
              à {{ activity.hours }}, {{ activity.adresse }}.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
